<template>
  <div>
    <transition name="slide" mode="out-in">
      <div
        ref="content"
        class="number-form"
        v-if="numberSaved === false"
        key="getNumber"
      >
        <h4>
          Haluatko kuulla vuoden kovimmista tarjouksista?
        </h4>
        <p class="air">
          Lisää alle vielä puhelinnumerosi, niin saat tiedon tarjouksista
          tekstarina!
        </p>
        <div class="inputs">
          <div class="input">
            <vs-input
              border
              type="tel"
              v-model="mobile"
              label-placeholder="Puhelinnumero"
              style="width:100%"
              @input="showButton"
            >
              <template #icon>
                <i class="bx bx-phone"></i>
              </template>
              <template #message-danger v-if="invalidMobile">
                Numero on muotoiltu väärin
              </template>
              <template #message-warn v-if="numberDoesNotHavePlus">
                Syötä numero suuntanumeron kanssa (+358)
              </template>
            </vs-input>
          </div>
          <div id="btnWrapper" class="button-wrapper">
            <vs-button @click="submit"
              ><i class="bx bx-save"></i> Tallenna
            </vs-button>
          </div>
        </div>
      </div>
      <div class="alert" v-if="alertActive" key="succes">
        <vs-alert success :progress="alertProgress" v-model="alertActive">
          <template #title>
            Numero tallennettu!
          </template>
          Puhelinnumerosi on tallennettu onnistuneesti, kiitos!
        </vs-alert>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import axios from "axios";

export default {
  name: "MobileForm",
  data: () => ({
    mobile: "",
    invalidMobile: false,
    numberDoesNotHavePlus: false,
    numberSaved: false,
    alertActive: false,
    alertTime: 6000,
    alertProgress: 0
  }),
  computed: mapGetters(["userData"]),
  watch: {
    alertActive(val) {
      if (val) {
        var interval = setInterval(() => {
          this.alertProgress++;
        }, this.alertTime / 100);

        setTimeout(() => {
          this.alertActive = false;
          clearInterval(interval);
          this.alertProgress = 0;
        }, this.alertTime);
      }
    }
  },
  methods: {
    ...mapActions(["saveMauticData"]),
    submit() {
      this.validateNumber();
      const loading = this.$vs.loading({
        target: this.$refs.content,
        type: "rectangle"
      });
      if (this.invalidMobile || this.numberDoesNotHavePlus) loading.close();
      else {
        const numberData = { mobile: this.mobile };
        axios
          .post(
            `https://www.lataapassi.fi/api/v1/mautic/crossgym/add-mobile/${this.userData.id}`,
            numberData
          )
          .then(() => {
            loading.close();
            this.alertActive = true;
            this.numberSaved = true;
          })
          .catch(error => {
            console.error(error);
            loading.close();
          });
      }
    },
    showButton() {
      const btnWrapper = document.getElementById("btnWrapper");
      if (this.mobile === "") btnWrapper.style.maxHeight = null;
      else btnWrapper.style.maxHeight = btnWrapper.scrollHeight + "px";
    },
    validateNumber() {
      const num = this.mobile.replace(/\s/g, "");
      if (num.indexOf("+") !== 0) this.numberDoesNotHavePlus = true;
      else this.numberDoesNotHavePlus = false;

      if (
        num.length < 10 ||
        num.length > 15 ||
        num.indexOf("-") !== -1 ||
        num.indexOf("e") !== -1
      )
        this.invalidMobile = true;
      else this.invalidMobile = false;
    }
  }
};
</script>

<style scoped>
h4 {
  margin: 2em 0 0.8em 0;
}
p {
  margin-bottom: 0.8em;
  font-size: 12px;
}
.number-form {
  position: relative;
}
.alert {
  margin-top: 2em;
  text-align: left;
}
.input >>> .vs-input {
  width: 100% !important;
  -moz-appearance: textfield;
}
.input >>> .vs-input::-webkit-outer-spin-button,
.input >>> .vs-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.vs-button {
  margin-left: auto;
}
.vs-button i {
  padding-right: 5px;
}
.button-wrapper {
  max-height: 0px;
  overflow: hidden;
  -webkit-transition: max-height 0.2s ease-out;
  transition: max-height 0.2s ease-out;
}
.slide-enter-active,
.slide-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.slide-enter,
.slide-leave-to {
  opacity: 0;
}
.slide-enter {
  transform: translateX(-30%);
}
.slide-leave-to {
  transform: translateX(30%);
}
</style>
